module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Quantities pa2-m pa4-l"
  }, [_c('div', {
    staticClass: "mw7-ns tl"
  }, [_c('p', {
    staticClass: "f4 mb5 lh-copy measure gray",
    domProps: {
      "innerHTML": _vm._s(_vm.settings.introductionText)
    }
  }), _c('h2', {
    staticClass: "f4 f3-l"
  }, [_vm._v("Quantity")]), _c('p', {
    staticClass: "f5 lh-copy measure gray",
    domProps: {
      "innerHTML": _vm._s(_vm.settings.quantityBeforeText)
    }
  }), _c('div', {
    staticClass: "pb2"
  }, [_c('div', {
    staticClass: "Box"
  }, [_c('strong', {
    staticClass: "BoxLabel"
  }, [_vm._v("Number of books")]), _c('bookart-number', {
    attrs: {
      "min": 50,
      "max": 5000,
      "step": 1
    },
    model: {
      value: (_vm.model.books),
      callback: function($$v) {
        _vm.$set(_vm.model, "books", $$v)
      },
      expression: "model.books"
    }
  })], 1), _c('div', {
    staticClass: "Spacer"
  }), _c('div', {
    staticClass: "Box"
  }, [_c('strong', {
    staticClass: "BoxLabel"
  }, [_vm._v("Number of pages")]), _c('bookart-number', {
    attrs: {
      "min": 4,
      "max": 1024,
      "step": 4
    },
    model: {
      value: (_vm.model.pages),
      callback: function($$v) {
        _vm.$set(_vm.model, "pages", $$v)
      },
      expression: "model.pages"
    }
  })], 1)]), _c('p', {
    staticClass: "f6 lh-copy measure gray pb2",
    domProps: {
      "innerHTML": _vm._s(_vm.settings.quantityAfterText)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44cfb82f!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartQuantities/BookartQuantities.vue
// module id = 188
// module chunks = 2